import { ListeContainer, useListe } from '@mairistem/liste';

import { baseUrl } from '@/routes';
import PayeurListe from './PayeurListe';

interface PayeurListeContainerProps {
  redirectOnEmpty?: boolean;
}

const PayeurListeContainer = ({ redirectOnEmpty }: PayeurListeContainerProps) => {
  const [listeService] = useListe(`${baseUrl}/payeurs`);

  return (
    <ListeContainer type="payeurs" contains="liste" service={listeService} perPage={15}>
      <PayeurListe redirectOnEmpty={redirectOnEmpty} />
    </ListeContainer>
  );
};

export default PayeurListeContainer;
